import { ChakraProvider } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import theme from "../shared/theme";
import queryClient from "./queryClient";
import router from "./router";
import { AuthProvider } from "../features/auth/context/AuthProvider";

// Único ChakraProvider do app (corrige o provider duplicado que existia em
// index.js + App.js — só o daqui aplica o tema).
export default function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}
